'use client';
import { useEffect, useState } from 'react';
// CHANGE 1: Swapped out import from 'react-input-mask' to 'react-imask'
import { IMaskInput } from 'react-imask';
import ErrorIcon from '@/components/customercenter-ui/svgs/error';
import SuccessIcon from '@/components/customercenter-ui/svgs/success';

interface InputMaskFieldProps {
  items?: string;
  id: string;
  type?: string;
  classname?: string;
  htmlFor?: string;
  value?: string;
  defaultValue?: string;
  disabled?: boolean;
  label?: string;
  errors?: any;
  register: any;
  createAccountFlag?: boolean;
  focusFirstName?: boolean;
  focusCardNumber?: boolean;
  onChange?: any;
  rules?: any;
  maxLength?: number;
  hideError?: boolean;
  isNum?: boolean;
  handleKeyPress?: (event: React.KeyboardEvent) => void;
  mask?: string;
}

const InputMaskField: React.FC<InputMaskFieldProps> = ({
  items,
  id,
  htmlFor,
  type = 'text',
  classname,
  value,
  defaultValue,
  disabled,
  label,
  errors,
  register,
  createAccountFlag = false,
  focusFirstName = false,
  focusCardNumber = false,
  onChange,
  rules,
  maxLength,
  hideError,
  isNum,
  handleKeyPress,
  mask,
}) => {
  const [isFocus, setIsFocus] = useState(false);
  const [valueField, setValueField] = useState(false);

  useEffect(() => {
    if (focusFirstName || focusCardNumber) {
      document.getElementById(id)?.focus();
    }
  }, [id, focusFirstName, focusCardNumber]);

  const combinedKeyPressHandler = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (
      isNum &&
      !/\d/.test(event.key) &&
      event.key !== 'Backspace' &&
      event.key !== 'Tab' &&
      event.key !== 'ArrowLeft' &&
      event.key !== 'ArrowRight'
    ) {
      event.preventDefault();
    }
    if (handleKeyPress) {
      handleKeyPress(event);
    }
  };

  // CHANGE 2: Manually destructure register variables to bypass the deleted findDOMNode issue
  const {
    ref,
    onChange: formOnChange,
    onBlur: formOnBlur,
    ...restRegister
  } = register(id, {
    onChange: (e: any) => {
      setValueField(/[0-9]/.test(e.target.value));
      onChange?.(e);
    },
    ...rules,
  });

  // CHANGE 3: Adapt standard mask syntax dynamically ('9' becomes '0' for numbers in imask)
  const structuralMask = mask ? mask.replace(/9/g, '0') : '';

  return (
    <>
      <div className="relative w-full">
        {/* CHANGE 4: Exchanged <InputMask> wrapper with <IMaskInput> */}
        <IMaskInput
          mask={structuralMask}
          id={id}
          className={
            'peer block appearance-none rounded-lg border bg-transparent p-4 pr-[2.5rem] text-base text-black ' +
            (errors?.[id] ? ' border-2 border-scarletRed ' : ' border-foggyGray ') +
            classname
          }
          placeholder=""
          value={value}
          defaultValue={defaultValue}
          type={type}
          disabled={disabled}
          maxLength={maxLength}
          onKeyPress={combinedKeyPressHandler}
          // CHANGE 5: Integrated modern React Hook Form properties safely
          inputRef={ref}
          onBlur={formOnBlur}
          onAccept={(unmaskedValue, maskRef) => {
            formOnChange({
              target: {
                name: id,
                value: maskRef.value,
              },
            });
          }}
          // CHANGE 6: Shifted legacy onBeforeInput event handling to a secure onFocus implementation
          onFocus={() => setIsFocus(true)}
          {...restRegister}
        />
        <label
          htmlFor={htmlFor}
          className={
            'absolute start-1 top-2 ml-1 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-base duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4' +
            (errors?.[id] ? ' text-scarletRed ' : '')
          }
        >
          {items}
        </label>
        {errors &&
          (errors[id] ? (
            <section
              className={
                'absolute top-5 ' +
                (label === 'password' || label === 'newPassword'
                  ? createAccountFlag
                    ? ' right-32 md:right-16 '
                    : ' right-16 '
                  : 'right-4 ')
              }
            >
              <ErrorIcon className="h-5 w-5" />
            </section>
          ) : (
            valueField &&
            isFocus && (
              <section
                className={
                  'absolute top-5 ' +
                  (label === 'password' || label === 'newPassword'
                    ? createAccountFlag
                      ? ' right-32 md:right-16 '
                      : ' right-16 '
                    : 'right-4 ')
                }
              >
                <SuccessIcon className="h-5 w-5" />
              </section>
            )
          ))}
      </div>
      <div className="mb-2">
        {!hideError && errors?.[id] && <p className="absolute mt-2 text-sm text-scarletRed">{errors[id]?.message}</p>}
      </div>
    </>
  );
};

export default InputMaskField;
